import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, savedInvite } from "@/lib/api";

const GuestCtx = createContext({ guest: null, loading: true, refresh: () => {} });

export function GuestProvider({ children }) {
  const [guest, setGuest] = useState(null);
  const [loading, setLoading] = useState(true);
  const refresh = useCallback(async () => {
    if (!savedInvite()) { setGuest(null); setLoading(false); return; }
    try {
      const r = await api.get("/public/guest");
      setGuest(r.data);
    } catch (e) {
      if (e.response?.status === 404) localStorage.removeItem("nigi_invite_token");
      setGuest(null);
    } finally { setLoading(false); }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  return <GuestCtx.Provider value={{ guest, loading, refresh }}>{children}</GuestCtx.Provider>;
}

export const useGuest = () => useContext(GuestCtx);

export const celebrationsLabel = (n) => (n === 1 ? "The Celebration" : "Our Celebrations");

const WORDS = ["Zero", "One", "Two", "Three", "Four", "Five", "Six"];
export const countWord = (n) => WORDS[n] || String(n);

export const invitedNames = (guest, slug) => (guest?.members || []).filter((m) => m.event_slugs.includes(slug)).map((m) => m.name);
